import React from 'react';
import { FormattedSimpleMsg } from 'GlobalFunctions';
import Loadings from '../../loadings/Loadings';
import { UiButton } from 'ui-components';
import topicModelingIcon from '../../../assets/img/topic-modeling.svg';

const TopicModelingNotification = ({
  itemData,
  removeNotification,
  notifId,
  loading = { [notifId]: false },
}) => {
  const { title, percent, tag_category_id } = itemData;
  /**
   * @param status
   * status=1 pending
   * status=2 processing
   * status=3 finished
   * status=4 failed
   */
  const status = parseInt(itemData.status);

  return (
    <Loadings type='box' spinning={!!loading[notifId]}>
      <div className='download-status-box'>
        <div className='progress-header'>
          <img
            src={topicModelingIcon}
            width={20}
            height={20}
            style={{
              width: '20px',
              marginLeft: '7px',
              marginRight: '6px',
            }}
          />
          <div className='text'>{title}</div>
          {notifId && (
            <UiButton
              type='icon'
              size='xxs'
              className='icon icon-close-icon '
              onClick={() => {
                removeNotification(notifId);
              }}
            />
          )}
        </div>

        <div className='progress-wrapper'>
          <div className='progress-bg'>
            {status === 1 && (
              <div className='progress-fg' style={{ width: '1%' }} />
            )}
            {status === 2 && (
              <div
                className={'progress-fg'}
                style={{ width: percent ? percent + '%' : '0%' }}
              />
            )}

            {status === 3 && <div className='progress-fg full' />}
          </div>

          <span>{percent ? Math.round(percent) + '%' : '0%'}</span>
        </div>

        <div className='progress-footer'>
          <div className='text'>
            {(status === 1 || status === 2) && (
              <p>
                <FormattedSimpleMsg id='notification.bulletin.in_progress' />
              </p>
            )}

            {status === 4 && (
              <p>
                <FormattedSimpleMsg id='notification.bulletin.error' />
              </p>
            )}

            {status === 3 && (
              <p>
                <FormattedSimpleMsg id='notification.bulletin.finish' />
              </p>
            )}
          </div>

          <div className='actions'>
            {status === 3 && (
              <>
                <UiButton
                  type='icon'
                  className='icon icon-eye'
                  size='xxs'
                  tooltip='مشاهده'
                  target='_blank'
                  href={`/topic-modelings/profile/${tag_category_id}`}
                  style={{
                    color: '#1C8CF8',
                    border: '1px solid #1C8CF8',
                  }}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </Loadings>
  );
};

export default TopicModelingNotification;
